
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/m/[m_alias]/[mid]/seite/[page]",
      function () {
        return require("private-next-pages/m/[m_alias]/[mid]/seite/[page].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/m/[m_alias]/[mid]/seite/[page]"])
      });
    }
  